import './App.css'
import {Menu, Board} from './components/Board/Board';

function App() {

  return (
    <div id="App">
      <Menu />
      <Board />
    </div>
  );
}

export default App;